export default {
    data() {
        return {
            moduleName: 'thematicGroups',
            detailPageRouteName: 'thematicGroupDetail',
            entity: {
                name: null,
                id_operator: 0,
                id_parent_thematic_group: null,
                translations: {
                    ces: '',
                    eng: '',
                    deu: '',
                    slk: '',
                    hun: '',
                },
                id_channels: [],
                custom_group: true,
            },
            updateFields: [
                'id_operator',
                'id_parent_thematic_group',
                'name',
                'translations',
                'device_visibility',
                'id_channels'
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/views/thematicGroups/mixins/thematicGroups.js